<!-- plan-section.component.html -->
<div class="plan-cards-row">
  <div class="plan-cards-container">
    <div
      *ngFor="let plan of config.plans; let i = index"
      [ngClass]="['platform', 'lowered']"
    >
      <div
        [ngClass]="[
          'card',
          'short-card',
          'card-' + i,
          plan.isPopular ? 'card-popular' : ''
        ]"
      >
        <div class="top">
          <div class="header">
            <div class="h3">
              {{ plan.title }}
              <span class="popular eyebrow-text" *ngIf="plan.isPopular">
                {{ config.strings.mostPopular }}
              </span>
            </div>
          </div>
          <div class="body">
            <div class="description">
              <div class="h5">
                {{ plan.description }}
              </div>
            </div>
            <div class="details-row">
              <div class="details-list">
                <div *ngFor="let detail of plan.details" class="list-item">
                  <div class="i">
                    <app-plus-icon
                      *ngIf="detail.icon === 'plus'"
                      [color]="plan.isPopular ? 'white' : ''"
                    ></app-plus-icon>
                    <app-confirmation-icon
                      *ngIf="detail.icon === 'confirm'"
                    ></app-confirmation-icon>
                  </div>
                  <div class="text">
                    <div class="h5" [innerHTML]="detail.text"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom">
          <!-- Integration Toggle Section -->
          <div *ngIf="plan.allowIntegration" class="integration-section">
            <div class="list-item">
              <label
                class="form-input-label"
                [for]="'integration-checkbox-' + plan.title"
                id="integration-toggle"
              >
                <input
                  type="checkbox"
                  id="{{'integration-checkbox-' + plan.title}}"
                  [(ngModel)]="integrationEnabled"
                  (change)="onIntegrationToggle()"
                />
                <div class="i">
                  <app-plus-icon
                    *ngIf="integrationEnabled"
                    [color]="'white'"
                  ></app-plus-icon>
                </div>
                <div id="integration-toggle-label" class="text">
                  <div class="h5" [innerHTML]="config.customerInfoForm.uiLabels.integrationCheckbox"></div>
                  <!-- Info Icon with Tooltip -->
                  <div class="icon-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <!-- Circle -->
                      <circle cx="9" cy="9" r="8" [attr.stroke]="'#48deda'" stroke-width="1.5" fill="none"/>
                      <!-- Lowercase "i" -->
                      <text x="9" y="12" font-family="Arial, sans-serif" font-size="10" font-weight="bold" text-anchor="middle" [attr.fill]="'#48deda'">i</text>
                    </svg>
                    <div class="tooltip">
                      <!-- Added Heading -->
                      <h6 class="tooltip-header">
                        {{ config.customerInfoForm.uiLabels.integrationListHeader }}
                      </h6>
                      <ul>
                        <li class="integration-list-item" *ngFor="let integration of config.integrations">
                          <strong>{{ integration.name }}</strong>: &nbsp;{{ integration.description || 'No description available.' }}&nbsp;
                          <span>({{ integration.price | currency:'USD':'symbol':'1.0-0' }})</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- End of Info Icon -->
                </div>
              </label>
            </div>
          </div>



          <div class="options-container">
            <div class="range-select-container">
              <label class="form-input-label" [for]="'select-sk-ecomm-estimated-usage-' + plan.title">
                {{ config.customerInfoForm.uiLabels.estimatedUsage }}
              </label>

              <select
                [id]="'select-sk-ecomm-estimated-usage-' + plan.title"
                class="form-input"
                [(ngModel)]="selectedRangeIndex"
                (ngModelChange)="onRangeIndexChange($event)"
              >
                <option *ngFor="let priceRange of plan.priceRanges; let i = index" [ngValue]="i">
                  {{ priceRange.min }}-{{ priceRange.max }} Tests
                </option>
              </select>
            </div>

            <!-- Integration Selection Dropdown -->
            <div *ngIf="plan.allowIntegration && integrationEnabled" class="integration-section">
              <label class="form-input-label" [for]="'select-sk-ecomm-add-integration-' + plan.title">
                {{ config.customerInfoForm.uiLabels.integrationDropdown }}
              </label>
              <select
                class="form-input"
                [(ngModel)]="selectedIntegration"
                (ngModelChange)="onIntegrationSelect($event)"
              >
                <option *ngFor="let integration of config.integrations" [ngValue]="integration">
                  {{ integration.name }} ({{ integration.price | currency:'USD':'symbol':'1.0-0' }})
                </option>
              </select>
            </div>
          </div>

          <div class="price-row">
            <div class="amount">
              <div class="h3">
                {{ getPlanPrice(plan, selectedRangeIndex) }}
              </div>
            </div>
            <div class="per">
              <div class="h5">&nbsp;/{{ plan.period }}</div>
            </div>
          </div>
          <div class="button-box">
            <app-web-button
              [id]="'btn-sk-ecomm-choose-plan-' + plan.title"
              [label]="selected?.title === plan.title ? config.strings.currentPlan : config.strings.choosePlan"
              [data]="plan.title"
              [style]="!plan.isPopular ? 'white' : 'aqua'"
              (clicked)="onChooseClick($event, plan)"
            ></app-web-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
